import { render, staticRenderFns } from "./StuProfile.vue?vue&type=template&id=11ad7fc4&scoped=true"
import script from "./StuProfile.vue?vue&type=script&lang=js"
export * from "./StuProfile.vue?vue&type=script&lang=js"
import style0 from "./StuProfile.vue?vue&type=style&index=0&id=11ad7fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ad7fc4",
  null
  
)

export default component.exports